import NavList from 'CategoryManagement/CategoryWidget/Components/NavList';
import React, { useEffect, useState } from 'react';
import {
	Breadcrumbs,
	NavGridContainer,
	Section,
	Table,
	TblContent,
	TblHeader,
	Td,
	Th,
	Title,
} from './SegmentedData.styles';
import Dashboard from '../DashBoard/Dashboard';
import {
	deletetModuleInfo,
	getModuleInfo,
	getSKUMapperFiles,
} from 'utils/apiRequests';
import { useHistory } from 'react-router-dom';
import AnalysisSvg from 'CategoryManagement/CategoryWidget/svgs/AnalysisSvg';
import NoData from 'CategoryManagement/CategoryWidget/SkuAnalysis/MultisourceSkuData/components/NoData.js';
import ModuleInfoModal from '../MultisourceSkuData/components/ModuleInfoModal';
import { KpiGridContainer } from 'CategoryManagement/CategoryManagement.styles';
import KpiList from './Components/KpiList/KpiList';
import {
	MODULE_KPI_NAME,
	MODULE_TIME_FEILDS,
	getDateFormated,
	getModuleInfoFormatting,
} from 'CategoryManagement/CategoryWidget/utils';
import {
	ApButtonDanger,
	ApLoaderDefault,
	ApLoaderText,
} from '@alixpartners/ui-components';
import { LoadingContainer } from 'Initiatives/Initiatives.styles';
import { DeleteDialog } from 'CategoryManagement/CategoryWidget/Components/DeleteMenu';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const SegmentedData = ({ setCurrentContent }) => {
	const [breadcrumbs, setBreadcrumbs] = useState(['Segmented Data']);
	const [content, setContent] = useState(0);
	const [categoryNav, setCategoryNav] = useState([]);
	const [moduleInfo, setmoduleInfo] = useState([]);
	const [moduleLoading, setModuleLoading] = useState(true);
	const [showModuleInfo, setShowModuleInfo] = useState(false);
	const [isModuleInfoLoading, setModuleInfoLoading] = useState(false);
	const [moduleInfoName, setModuleInfoName] = useState('');
	const [showDeleteInfo, setShowDeleteInfo] = useState(false);
	const [moduleInfoId, setModuleInfoId] = useState(null);
	const [showFilters, setShowFilters] = useState(false);
	const [filter, setFilters] = useState([]);
	const history = useHistory();
	useEffect(
		() => {
			getSKUMapperFiles()
				.then(({ data }) =>
					setCategoryNav(
						data.map(d => ({
							key: d.id,
							title: d.uI_Name,
							filters: d.filterjson,
							icon: AnalysisSvg,
						}))
					)
				)
				.then(() => {
					setModuleLoading(false);
				});
		},
		[content]
	);

	useEffect(() => {
		history.push({
			pathname: '/category-management/category-widgets',
			search: '?isSegment=true', // query string
			state: {
				// location state
				isSegment: true,
			},
		});
	}, []);
	const handleModuleInformation = async (id, moduleName) => {
		setModuleInfoLoading(true);
		setModuleInfoName(moduleName);
		await getModuleInfo({ modelId: id })
			.then(response => {
				const titles = Object.keys(response.data[0]);
				const values = Object.values(response.data[0]);
				const moduleInfoArray = [];
				for (let index = 0; index < titles.length; index++) {
					moduleInfoArray.push({
						title: MODULE_KPI_NAME[titles[index]],
						value: MODULE_TIME_FEILDS.includes(titles[index])
							? getDateFormated('en-US', values[index]).replace(',', '')
							: values[index],
					});
				}
				const newData = getModuleInfoFormatting(moduleInfoArray);
				setmoduleInfo(newData);
				setModuleInfoLoading(false);
			})
			.catch(() => setModuleInfoLoading(false));
	};
	const handleModuleDelete = async (id, moduleName) => {
		setModuleInfoName(moduleName);
		setShowDeleteInfo(true);
		setModuleInfoId(id);
	};
	const handleDelete = async () => {
		// moduleInfoId
		await deletetModuleInfo(moduleInfoId).then(() => {
			getSKUMapperFiles().then(({ data }) =>
				setCategoryNav(
					data.map(d => ({
						key: d.id,
						title: d.uI_Name,
						icon: AnalysisSvg,
						filters: d.filterjson,
					}))
				)
			);
		});
		setShowDeleteInfo(false);
		setModuleInfoId(null);
		setModuleInfoName('');
	};
	const handleInformationClose = () => {
		setShowModuleInfo(false);
		setShowFilters(false);
		setFilters([]);
	};
	const handleUpdateFilters = () => {
		const moduleInfo = categoryNav.find(a => a.title === moduleInfoName);
		history.push({
			pathname: '/category-management/category-widgets',
			search: '?isMaster=true', // query string
			state: {
				// location state
				isMaster: true,
				updateFilterData: {
					id: moduleInfo.key,
					name: moduleInfo.title,
					filters: moduleInfo.filters,
				},
			},
		});
	};
	if (moduleLoading) {
		return (
			<div style={{ marginTop: '200px' }}>
				<ApLoaderDefault loaderText={() => <ApLoaderText />} />
			</div>
		);
	}
	return (
		<>
			{content === 0 && (
				<Breadcrumbs>
					<span onClick={() => setCurrentContent(0)}>SKU Analysis</span>&nbsp;/&nbsp;<span
					>
						Segmented Data
					</span>
				</Breadcrumbs>
			)}
			{showModuleInfo && (
				<ModuleInfoModal
					title={`Module Information for ${moduleInfoName}`}
					handleClose={handleInformationClose}
				>
					{isModuleInfoLoading ? (
						<LoadingContainer>
							<ApLoaderDefault loaderText={() => <ApLoaderText />} />
						</LoadingContainer>
					) : (
						<span>
							<KpiGridContainer>
								<KpiList
									data={moduleInfo || []}
									setShowFilters={setShowFilters}
									setFilters={setFilters}
								/>
							</KpiGridContainer>
							{showFilters && (
								<Section>
									<TblHeader>
										<Table cellPadding="0" cellSpacing="0" border="0">
											<thead>
												<tr>
													<Th>Name</Th>
													<Th>Filters</Th>
													<Th>Count</Th>
												</tr>
											</thead>
										</Table>
									</TblHeader>
									<TblContent>
										<Table cellPadding="0" cellSpacing="0" border="0">
											<tbody>
												{filter.map(data => (
													<tr>
														<Td>{data.name}</Td>
														<Td>
															{JSON.stringify(data.data)
																.replace('[', '')
																.replace(']', '')}
														</Td>
														<Td>{data.count}</Td>
													</tr>
												))}
											</tbody>
										</Table>
									</TblContent>
									<br />
									<div
										style={{ display: 'flex', justifyContent: 'flex-end' }}
										onClick={handleUpdateFilters}
									>
										<ApButtonDanger>Update Filters</ApButtonDanger>
									</div>
								</Section>
							)}
						</span>
					)}
				</ModuleInfoModal>
			)}
			{showDeleteInfo && (
				<DeleteDialog
					title={'Delete Module'}
					text={`You are about to delete this Module(${moduleInfoName}). Are you sure you want to proceed?`}
					onDelete={() => handleDelete()}
					onClose={() => setShowDeleteInfo(false)}
				/>
			)}
			{content === 0 ? (
				<>
					{categoryNav.length != 0 ? (
						<NavGridContainer>
							<NavList
								navArray={categoryNav}
								setContent={setContent}
								isChild={true}
								showModuleInfo={setShowModuleInfo}
								handleModuleInformation={handleModuleInformation}
								handleModuleDelete={handleModuleDelete}
							/>
						</NavGridContainer>
					) : (
						<NoData />
					)}
				</>
			) : (
				<Dashboard
					setContent={setContent}
					breadcrumbs={breadcrumbs}
					content={content}
					dashboardData={categoryNav.filter(nav => nav.key === content)}
					filterSaved={categoryNav.filter(category => category.key === content)}
				/>
			)}
		</>
	);
};

export default SegmentedData;
